import { useEffect, useRef, useState } from "react";
import { api } from "../../lib/api";
import { MapPin, Loader2 } from "lucide-react";

export function AddressInput({ value, onSelect, onChange, placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);
  const boxRef = useRef(null);

  const query = (text) => {
    onChange(text);
    clearTimeout(timer.current);
    if (text.trim().length < 3) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      setBusy(true);
      try {
        const { data } = await api.get("/geo/autocomplete", { params: { q: text } });
        setResults(data);
        setOpen(data.length > 0);
      } catch { setResults([]); }
      setBusy(false);
    }, 380);
  };

  useEffect(() => {
    const close = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--cc-accent)] pointer-events-none" />
      <input value={value} onChange={(e) => query(e.target.value)} data-testid={testid} placeholder={placeholder}
        autoComplete="off"
        className="w-full h-14 rounded-2xl border bg-card pl-11 pr-10 text-base font-medium focus:outline-none focus:border-[var(--cc-accent)] focus:ring-2 focus:ring-[var(--cc-accent)]/20 transition-colors duration-200 placeholder:text-muted-foreground/60" />
      {busy && <Loader2 className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-muted-foreground" />}
      {open && (
        <div className="absolute z-40 mt-2 left-0 right-0 rounded-2xl border bg-popover shadow-2xl overflow-hidden" data-testid={`${testid}-dropdown`}>
          {results.map((r, i) => (
            <button key={i} type="button" data-testid={`${testid}-option-${i}`}
              onClick={() => { onSelect(r); setOpen(false); }}
              className="w-full text-left px-4 py-3.5 text-sm hover:bg-secondary flex items-start gap-2.5 transition-colors duration-150 border-b last:border-b-0">
              <MapPin className="w-4 h-4 text-[var(--cc-accent)] mt-0.5 shrink-0" />
              <span className="line-clamp-2">{r.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
